import { Amenity, useAmenities } from "./Amenities.hook";
import { CSSProperties, useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import React from "react";
import "./styles.less"
import { ArrowIcon } from "shared-components/Components/CustomIcons/ArrowIcon/web";


interface AmenitiesProps {
    openByDefault?: boolean;
    style?: CSSProperties
}

export const Amenities = ({ openByDefault, style={} } : AmenitiesProps) => {
    const { country_code } = useContext(ConfigStateContext);
    const {
        showComponent,
        amenitiesToShow,
        showMore,
        handleSelect,
        isActive
    } = useAmenities({
        country_code,
        openByDefault
    });

    if (!showComponent) return null;

    return (
        <div className="filter amenities-filter" style={style}>
            <h3 className="filter-title">Extras</h3>

            <div className="boxes-container">
                {amenitiesToShow.main.map((amenity, index) => {
                    const active = isActive(amenity.id);

                    return (
                        <div
                            key={'amenities-' + index}
                            className={`boxes-container__item ${active ? "boxes-container__item--active" : ""}`}
                            onClick={() => handleSelect(amenity)}
                        >
                            <span className="icon-container">
                                <amenity.icon />
                            </span>
                            <span className="text">{amenity.nombre}</span>
                        </div>
                    )}
                )}
            </div>

            {showMore.value && amenitiesToShow.extra.map((option, index) => (
                <div
                    key={`amenity-group-${index}`}
                    className={`${!option.group ? "without-title" : ""}`}
                >
                   {option.group ? <h3 className="amenities-filter__subtitle">{option.group}</h3> : null}

                    <div className="boxes-container">
                        {option.amenities.map((amenity, index) => {
                            const active = isActive(amenity.id);

                            return (
                                <div
                                    key={'amenities-' + index}
                                    className={`boxes-container__item ${active ? "boxes-container__item--active" : ""}`}
                                    onClick={() => handleSelect(amenity)}
                                >
                                    <span className="icon-container">
                                        <amenity.icon />
                                    </span>
                                    <span className="text">{amenity.nombre}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
                )
            )}
            
            <div className="show-more__container">
                <button
                    onClick={()=> showMore.set(!showMore.value)}
                    className="show-more__button"
                >
                    <span style={{}}>{showMore.value ? 'Ver menos' : 'Ver más'}</span>
                    {showMore.value ? <ArrowIcon type="top" /> : <ArrowIcon type="bottom" />}
                </button>
            </div>

            <hr style={{width:"100%", border:'none', borderTop:'1px solid rgba(0,0,0,.06)', margin:'24px 0'}} />
        </div>
    )
}